import React from 'react'
import { Form, Input, Button, Modal, InputNumber, Checkbox } from 'antd'

import { keys } from '../../actions/pageTemplateForm'

import MultiLanguageField from '../../components/MultiLanguageField'

const FormItem = Form.Item
const { TextArea } = Input

class ItemForm extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleOnSubmit = this.handleOnSubmit.bind(this)
    this.handleOnDelete = this.handleOnDelete.bind(this)
  }

  handleOnSubmit(e) {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (err) {
        return
      }
      console.log(values)
      this.props.onSubmit({
        ...values,
        template_name: 'hero-text',
        template_elements: {
          text: { 'en-US': true },
          sectionAnchor: true,
        },
      })
    })
  }

  handleOnDelete(e) {
    e.preventDefault()
    const handleOnOk = () => { this.props.onDelete() }
    Modal.confirm({
      title: 'Delete Item',
      content: 'Are you sure to delete this item?',
      okType: 'danger',
      onOk() {
        handleOnOk()
      },
      onCancel() {
        // console.log('Cancel')
      },
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
        md: { span: 10 },
      },
    }
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 12,
          offset: 7,
        },
      },
    }
    const isCreateForm = this.props.type === 'create'
    return (
      <Form onSubmit={this.handleOnSubmit}>
        <FormItem label='Disable?' {...formItemLayout}>
          {getFieldDecorator('disable', {
            valuePropName: 'checked',
          })(<Checkbox autoComplete='off' />)}
        </FormItem>
        <FormItem label='URL Anchor (Optional)' {...formItemLayout}>
          {getFieldDecorator('sectionAnchor', {
          })(<Input />)}
        </FormItem>
        <FormItem label='Order' {...formItemLayout}>
          {getFieldDecorator('order', {
            initialValue: 1,
            rules: [{ required: true, message: 'Please input a valid value.' }],
          })(<InputNumber />)}
        </FormItem>
        <MultiLanguageField
          label='Text'
          field='text'
          formItemLayout={formItemLayout}
          getFieldDecorator={getFieldDecorator}
          textArea={true}
          data={this.props.formFieldValues}
        />
        <FormItem {...tailFormItemLayout}>
          <Button
            loading={this.props.isCreateItemLoading || this.props.isEditItemLoading}
            type='primary'
            htmlType='submit'
            style={{ marginRight: '12px' }}
          >
            {isCreateForm ? 'Create' : 'Save'}
          </Button>
          {
            !isCreateForm &&
            <Button
              loading={this.props.isDeleteItemLoading}
              type='danger'
              htmlType='button'
              onClick={this.handleOnDelete}
            >
              Delete
            </Button>
          }
        </FormItem>
      </Form>
    )
  }
}

const CustomizedForm = Form.create({
  onFieldsChange(props, changedFields) {
    props.onFieldsChange(changedFields)
  },
  mapPropsToFields(props) {
    const { formFieldValues = {} } = props
    const ks = keys.length === 0 ? Object.keys(formFieldValues) : keys
    const fields = ks.reduce((prev, key) => (
      { ...prev, [key]: Form.createFormField(formFieldValues[key]) }
    ), {})
    return fields
  },
  // onValuesChange(_, values) {
  //   console.log(values)
  // },
})(ItemForm)

export default CustomizedForm
